export const GET_BOARD_REMINDER = "GET_BOARD_REMINDER";
export const NEW_BOARD_REMINDER = "NEW_BOARD_REMINDER";
export const EDIT_BOARD_REMINDER = "EDIT_BOARD_REMINDER";
export const DELETE_BOARD_REMINDER = "DELETE_BOARD_REMINDER";
export const NEW_BOARD_TASK_REMINDER = "NEW_BOARD_TASK_REMINDER";
export const GET_BOARD_TASKS_REMINDERS = "GET_BOARD_TASKS_REMINDERS";
export const GET_BOARD_TASK_REMINDERS = "GET_BOARD_TASK_REMINDERS";
export const NEW_BOARD_TASKMAP_REMINDER = "NEW_BOARD_TASKMAP_REMINDER";
export const EDIT_BOARD_TASK_REMINDER = "EDIT_BOARD_TASK_REMINDER";
export const DELETE_BOARD_TASK_REMINDER = "DELETE_BOARD_TASK_REMINDER";
export const EDIT_BOARD_TASKMAP_REMINDER = "EDIT_BOARD_TASKMAP_REMINDER";
export const DELETE_BOARD_TASKMAP_REMINDER = "DELETE_BOARD_TASKMAP_REMINDER";